import React from 'react';
import DashboardIcon from '@mui/icons-material/Dashboard';
import SchoolIcon from '@mui/icons-material/School';
import PeopleIcon from '@mui/icons-material/People';
import AssignmentIcon from '@mui/icons-material/Assignment';
import FolderIcon from '@mui/icons-material/Folder';
import SecurityIcon from '@mui/icons-material/Security';
import GradingIcon from '@mui/icons-material/Grading';
import SettingsIcon from '@mui/icons-material/Settings';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import CommentIcon from '@mui/icons-material/Comment';
import ForumIcon from '@mui/icons-material/Forum';
import RuleIcon from '@mui/icons-material/Rule';
import CableIcon from '@mui/icons-material/Cable';
import BusinessIcon from '@mui/icons-material/Business';
import CorporateFareIcon from '@mui/icons-material/CorporateFare';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import MenuBookIcon from '@mui/icons-material/MenuBook';

const NAV_ICONS: Record<string, React.ReactElement> = {
  dashboard: <DashboardIcon />,
  school: <SchoolIcon />,
  people: <PeopleIcon />,
  assignment: <AssignmentIcon />,
  folder: <FolderIcon />,
  security: <SecurityIcon />,
  grading: <GradingIcon />,
  settings: <SettingsIcon />,
  upload: <CloudUploadIcon />,
  comment: <CommentIcon />,
  forum: <ForumIcon />,
  rule: <RuleIcon />,
  cable: <CableIcon />,
  business: <BusinessIcon />,
  corporate_fare: <CorporateFareIcon />,
  auto_awesome: <AutoAwesomeIcon />,
  menu_book: <MenuBookIcon />,
};

export const getIconComponent = (iconName?: string): React.ReactElement => {
  if (!iconName) return <DashboardIcon />;
  return NAV_ICONS[iconName] || <DashboardIcon />;
};
